import Vue from 'vue'
import Router from 'vue-router'
import IdeaSpaces from '@/components/IdeaSpaces'
import Admin from '@/components/Admin'
import Login from '@/components/Login'
import Ideas from '@/components/Ideas'
import Idea from '@/components/Idea'
import IdeaEdit from '@/components/IdeaEdit'
import Topic from '@/components/Topic'
import Topics from '@/components/Topics'
import TopicEdit from '@/components/TopicEdit'
import Profile from '@/components/Profile'
import ProfileEdit from '@/components/ProfileEdit'
import UserEdit from '@/components/UserEdit'
import PassList from '@/components/PassList'
import Redirect from '@/components/Redirect'
import Delegate from '@/components/Delegate'
import Page from '@/components/Page'
import store from '@/store'
import SentryIntegration from '@/utils/sentry.integration'
import GroupsUsers from '@/components/GroupsUsers'
import RoleEdit from '@/components/RoleEdit'
import School from '@/components/School'
import PagesAdmin from '@/components/PagesAdmin'
import IdeaSpaceAdmin from '@/components/IdeaSpaceAdmin'
import LinksAdmin from '@/components/LinksAdmin'
import Phase from '@/components/Phase'
import Categories from '@/components/Categories'
import Quorum from '@/components/Quorum'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'IdeaSpaces',
      component: IdeaSpaces,
      meta: {auth: true}
    },
    {
      path: '/space/:spaceSlug/ideas',
      name: 'Ideas',
      component: Ideas,
      meta: {auth: true}
    },
    {
      path: '/space/:spaceSlug/idea/:ideaId/edit',
      name: 'IdeaEdit',
      props: {isEditing: true},
      component: IdeaEdit,
      meta: {auth: true}
    },
    {
      path: '/space/:spaceSlug/idea/create/:topicId?',
      name: 'IdeaCreate',
      component: IdeaEdit,
      meta: {auth: true}
    },
    {
      path: '/space/:spaceSlug/idea/:ideaId/view',
      name: 'IdeaView',
      component: Idea,
      meta: {auth: true}
    },
    {
      path: '/space/:spaceSlug/topics',
      name: 'Topics',
      component: Topics,
      meta: {auth: true}
    },
    {
      path: '/space/:spaceSlug/topics/create',
      name: 'TopicCreate',
      component: TopicEdit,
      meta: {auth: true}
    },
    {
      path: '/space/:spaceSlug/topics/:topicId',
      name: 'Topic',
      component: Topic,
      meta: {auth: true}
    },
    {
      path: '/space/:spaceSlug/topics/:topicId/edit',
      name: 'TopicEdit',
      component: TopicEdit,
      meta: {auth: true}
    },
    {
      path: '/space/:spaceSlug/topics/:topicId/delegate',
      name: 'Delegate',
      component: Delegate,
      meta: {auth: true}
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {auth: false}
    },
    {
      path: '/admin',
      component: Admin,
      meta: {auth: true},
      children: [
        {
          path: '',
          redirect: 'users'
        },
        {
          path: 'users',
          component: GroupsUsers
        },
        {
          path: 'roleEdit',
          component: RoleEdit
        },
        {
          path: 'community',
          component: School
        },
        {
          path: 'pages',
          component: PagesAdmin
        },
        {
          path: 'links',
          component: LinksAdmin
        },
        {
          path: 'ideaSpace',
          component: IdeaSpaceAdmin
        },
        {
          path: 'phaseDuration',
          component: Phase
        },
        {
          path: 'categories',
          component: Categories
        },
        {
          path: 'quorum',
          component: Quorum
        }
      ]
    },
    {
      path: '/admin/password-printout',
      name: 'PassList',
      component: PassList,
      meta: {auth: true}
    },
    {
      path: '/user/settings',
      name: 'UserEdit',
      component: UserEdit,
      meta: {auth: true}
    },
    {
      path: '/user/:userId',
      name: 'Profile',
      component: Profile,
      meta: {auth: true}
    },
    {
      path: '/user/:userId/edit',
      name: 'ProfileEdit',
      component: ProfileEdit,
      meta: {communityId: 1, auth: true}
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Page,
      props: {communityId: 1, pageName: 'impressum'},
      meta: {}
    },
    {
      path: '/terms',
      name: 'terms',
      component: Page,
      props: {communityId: 1, pageName: 'terms'},
      meta: {}
    },
    {
      path: '/page/:pageName',
      name: 'Page',
      props: true,
      component: Page,
      meta: {}
    },
    {
      path: 'Redirect/:path',
      name: 'Redirect',
      component: Redirect,
      meta: {auth: true}
    }

  ]
})

router.beforeResolve((to, from, next) => {
  var selectedSchool = store.getters.selected_school
  if (to.path === '/admin') {
    next()
    return
  }

  if (to.path !== '/login' && selectedSchool < 0 && (store.getters.user.profile.role && store.getters.user.profile.role.indexOf('admin') >= 0)) {
    next({path: '/admin'})
    return
  }

  if (to.name) {
    store.commit('SET_LOADING', true)
  }

  SentryIntegration.configureSentryScope({
    'extras': {
      'route': to
    },
    'tags': {
      'url': to.fullPath
    }
  })

  next()
})

router.afterEach((to, from) => {
  store.commit('SET_LOADING', false)
})

export default router
